export default {
  DELETE_ELEMENT: 'ws:delete_element',
  INSERT_ELEMENT: 'ws:insert_element',
};
